class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('#search-input');
    this.predictiveSearchResults = document.querySelector('#search-results');
    this.searchType = this.getAttribute('data-search-type');

    // if (this.searchType === 'tier_1') return;

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = encodeURIComponent(this.input.value.trim());

    if (!searchTerm.length) {
      if (this.searchType === 'tier_1') {
        $('.search__hint').removeClass('show');
        return;
      }

      if (this.querySelector('.mobile-search-bar__footer')) {
        $(this.querySelector('.mobile-search-bar__footer')).fadeIn();
      }

      if (this.querySelector('.search__initial')) {
        $(this.predictiveSearchResults).fadeOut(function () {
          $('.search__initial').fadeIn();
        });
      } else {
        $(this.predictiveSearchResults).fadeOut();
      }

      return;
    } else {
      if (this.searchType === 'tier_1') {
        $('.search__hint').addClass('show');
        return;
      }

      if (this.querySelector('.mobile-search-bar__footer')) {
        $(this.querySelector('.mobile-search-bar__footer')).fadeOut();
      }
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search?q=${searchTerm}&type=product,article,page,collection&options[unavailable_products]=show&options[prefix]=last&view=predictive`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();

          throw error;
        }

        return response.text();
      })
      .then((text) => {
        // console.log({ text });
        if (text.indexOf('no-results') != -1) {
          $('.navbar__search').addClass('search-results--no-results');
          return;
        }

        $('.navbar__search').removeClass('search-results--no-results');

        // const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        const resultsMarkup = text;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        window.updateProductCardsWishlist?.();

        if (
          $('.search__initial').length &&
          $('.search__initial').is(':visible')
        ) {
          $(this.predictiveSearchResults).hide();

          $('.search__initial').fadeOut(() => {
            this.open();
          });
        } else {
          this.open();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    $(this.predictiveSearchResults).fadeIn();
    console.log('open');
  }

  close() {
    $(this.predictiveSearchResults).fadeOut();
    console.log('close');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
